import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { advertisementsUpdateItem } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { PROGRAM_CINEMAS, FEATURES, CLI_CINEMA_CLIENT_ID, PROGRAM_ADVERTISEMENTS_ITEMS, WPSERVER } from '../../../constants/state'
import EditAdvertisements from '../present/EditAdvertisements'
import { push } from 'connected-react-router'


const mapStateToProps = (state, ownProps) => ({
    itemData: getData(state, [PROGRAM_ADVERTISEMENTS_ITEMS, ownProps.itemId]),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    sliderAppearance: state.getIn([WPSERVER, 'data', 'data', 'front', 'slider_appearance']),
    bannerAppearance: state.getIn(['wpServerData', 'data', 'data', 'advertisement_config', 'program_overview_tiles_style'])
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(advertisementsUpdateItem(ownProps.itemId, itemData))
        dispatch(push(ownProps.closePagePath))
    }
})


const EditAdvertisementsContainer = ({itemData, onUpdateItem, cliCinemas, features, sliderAppearance, bannerAppearance, closePagePath, clientCinemaId}) => <EditAdvertisements
    itemData={itemData}
    cliCinemas={cliCinemas}
    clientCinemaId={clientCinemaId}
    features={features}
    sliderAppearance={sliderAppearance}
    bannerAppearance={bannerAppearance}
    closePagePath={closePagePath}
    onUpdateItem={onUpdateItem}
/>


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditAdvertisementsContainer)